var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { checkSingleEmail } from '@xylabs/sdk-coin-js';
import { getLocalStorageObject, setLocalStorageObject } from '@xyo-network/sdk-xyo-react-js';
class ContactInfo {
    constructor() {
        this.data = {};
        this.load();
    }
    getData() {
        return this.data;
    }
    getSanitizedData() {
        const result = JSON.parse(JSON.stringify(this.data));
        delete result.email;
        delete result.lastName;
        delete result.firstName;
        delete result.phone;
        return result;
    }
    save() {
        setLocalStorageObject('contactInfo', this.data);
    }
    load() {
        this.data = getLocalStorageObject('contactInfo');
    }
    clear() {
        localStorage.removeItem('contactInfo');
    }
    setFirstName(value) {
        this.data.firstName = value;
        this.save();
    }
    validateFirstName() {
        var _a, _b;
        if (!(((_b = (_a = this.data.firstName) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error('First name may not be empty');
        }
    }
    setLastName(value) {
        this.data.lastName = value;
        this.save();
    }
    validateLastName() {
        var _a, _b;
        if (!(((_b = (_a = this.data.lastName) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error('Last name may not be empty');
        }
    }
    setEmail(value) {
        this.data.email = value;
        this.save();
    }
    validateEmail(debounce) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const email = this.data.email;
            if (!email || email.length === 0) {
                return Error('Email may not be empty');
            }
            if (debounce) {
                const check = yield checkSingleEmail(email);
                if (((_a = check.debounce) === null || _a === void 0 ? void 0 : _a.send_transactional) !== '1') {
                    this.suggestedEmail = (_b = check.debounce) === null || _b === void 0 ? void 0 : _b.did_you_mean;
                    return Error('Email in invalid');
                }
            }
        });
    }
    setPhone(value) {
        this.data.phone = value;
        this.save();
    }
    validatePhone() {
        var _a, _b;
        if (!(((_b = (_a = this.data.phone) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) > 0)) {
            return Error('Phone name may not be empty');
        }
    }
    valid() {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.errors()).length === 0;
        });
    }
    errors() {
        return __awaiter(this, void 0, void 0, function* () {
            return [this.validateFirstName(), this.validateLastName(), yield this.validateEmail()].filter((item) => item !== undefined);
        });
    }
    static get() {
        var _a;
        this.instance = (_a = this.instance) !== null && _a !== void 0 ? _a : new ContactInfo();
        return this.instance;
    }
}
export default ContactInfo;
